import { defineStore } from 'pinia';

export const useSplitViewStore = defineStore('splitView', {
  state: () => ({
    isSplitView: JSON.parse(localStorage.getItem('isSplitView') || 'true'), // Default: SplitView aktiv
  }),
  actions: {
    toggleViewMode() {
      this.isSplitView = !this.isSplitView;
      localStorage.setItem('isSplitView', JSON.stringify(this.isSplitView));
    },
  },
  persist: true,
});
